import _ from 'lodash';
import keyMirror from 'keymirror';

const CONSTANTS = {
	STATUS: {
		INITIAL: 'initial',
		BUSY: 'busy',
		SUCCESS: 'success',
		FAILED: 'failed',
	},
};

// Define action constants
export default _.extend(
	{},
	CONSTANTS,
	keyMirror({
		BANK_TRANSFER_FAILED: null,
		BANK_TRANSFER_SUCCESS: null,
		BANK_TRANSFER_LOADING: null,
		BANK_TRANSFER_PROGRESS: null,
		BANK_TRANSFER_RESET: null,
	}),
);
